import { render, staticRenderFns } from "./GamePreparationCounter.vue?vue&type=template&id=11f34883&scoped=true&lang=pug&"
import script from "./GamePreparationCounter.vue?vue&type=script&lang=js&"
export * from "./GamePreparationCounter.vue?vue&type=script&lang=js&"
import style0 from "./GamePreparationCounter.vue?vue&type=style&index=0&id=11f34883&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f34883",
  null
  
)

export default component.exports